import Http from '@/utils/http/index';

export default {
  /**
   * 用户自主争议列表
   */
  queryList(params) {
    return Http.get('/merDispute/merchant/list', { params });
  },

  queryDetail(params) {
    return Http.get('/merDispute/merchant/detail', { params });
  },

  postAudit(data) {
    return Http.post('/merDispute/merchant/audit', data);
  },
};
